import cookieInstance from './Cookie';
export function getCountryPrice(price) {
  if (!cookieInstance.getCookie('country')) {
    return price;
  }
  price = +price;
  if (isNaN(price)) return;
  var countryAmount = cookieInstance.getCookie('country_amount');
  var countryPriceType = cookieInstance.getCookie('country_price_type');
  if (!countryAmount || !countryPriceType) {
    //console.log('no cookie!');
    return false;
  }
  countryAmount = +countryAmount;
  switch (countryPriceType) {
    case 'increase_fixed':
      price -= countryAmount;
      break;
    case 'decrease_fixed':
      price += countryAmount;
      break;
    case 'increase_percentage':
      price = price * 100 / (100 + countryAmount);
      break;
    case 'decrease_percentage':
      price = price * 100 / (100 - countryAmount);
      break;
    case 'fixed_price':
      break;
  }
  console.log('price changed: ', price);
  return +price.toFixed(2);
}